var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"numpad",staticClass:"numpad"},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.value,staticClass:"info",class:{ 'active' : button.active },on:{"click":function($event){return _vm.sendTone(button.value)}}},[_vm._v(_vm._s(button.value))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }